/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   getDistanceFromCenter
 */

import { isNumber } from '@zcode/utils'
import { distance as computeDistance } from '../utils'

export interface Coords {
  lat: number
  lng: number
}

export interface MaybeCoords {
  lat?: number | null
  lng?: number | null
}

interface GetDistanceFromCenter {
  (center: Coords, entity: Coords): number
  (center: undefined | null, entity: MaybeCoords): undefined
  (center: MaybeCoords | null, entity: MaybeCoords): number | undefined
}

const getDistanceFromCenter = ((center: MaybeCoords, entity: MaybeCoords) => {
  const { lat, lng } = entity

  if (
    !isNumber(lat) ||
    !isNumber(lng) ||
    !center ||
    !isNumber(center.lat) ||
    !isNumber(center.lng)
  ) {
    return undefined
  }
  const distance = computeDistance({
    lat1: lat,
    lng1: lng,
    lat2: center.lat,
    lng2: center.lng,
  })
  return distance
}) as GetDistanceFromCenter

export default getDistanceFromCenter
